<template>
    <div class="login-page">
        <div class="centerer">
            <div class="login-card">
                <div class="form-side">
                    <el-form :model="form" ref="form" :rules="rules" label-position="top" v-loading="isLoading">
                        <el-form-item label="公司 ID" prop="company">
                            <el-input
                                type="text"
                                name="company-id"
                                v-model.trim="companyId"
                                ref="companyInput"
                                class="company-id-input"
                                @keyup.enter.native="switchInputFocus('email')"
                                maxlength="25"
                            />
                        </el-form-item>
                        <el-form-item label="帳號 (E-mail)" prop="email">
                            <el-input type="text" name="username" v-model.trim="form.email" ref="emailInput" @keyup.enter.native="switchInputFocus('password')" maxlength="100" />
                        </el-form-item>
                        <el-row align="top" style="margin-top: 30px;">
                            <el-col :sm="12" align="left">
                                <el-button class="forgot-pass-btn" style="cursor: default;" @click="handleBackBtnClick">回登入頁</el-button>
                            </el-col>
                            <el-col :sm="12" align="">
                                <el-button id="login-page-submit-btn" type="primary" @click="handleSubmitBtnClick" :loading="isLoading" style="max-width: 200px;">發送密碼信</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LoginPage',
    components: {},
    data() {
        return {
            isLoading: false,
            errorMsg: '',
            submitBtnTouchStatus: '',
            form: {
                company: '',
                email: '',
                password: '',
            },

            // 表單驗證
            rules: {
                company: [{ required: true, message: '請輸入公司 ID', trigger: 'blur' }],
                email: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
                password: [{ required: true, message: '請輸入密碼', trigger: 'blur' }],
            },
        };
    },
    computed: {
        companyId: {
            get() {
                return this.form.company;
            },
            set(val) {
                this.form.company = val.toUpperCase();
            },
        },
    },
    methods: {
        switchInputFocus(target) {
            if (target == 'company') {
                this.$refs.companyInput.$el.querySelector('input').focus();
            } else if (target == 'email') {
                this.$refs.emailInput.$el.querySelector('input').focus();
            } else if (target == 'password') {
                this.$refs.passwordInput.$el.querySelector('input').focus();
            }
        },
        handleSubmitBtnClick() {
            this.errorMsg = '';
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.login();
                }
            });
        },

        handleBackBtnClick() {
            this.$router.push({ name: 'login' });
        },

        onSubmitTouchStart() {
            this.submitBtnTouchStatus = 'touching';
        },

        onSubmitTouchEnd() {
            this.submitBtnTouchStatus = '';
        },
        login() {
            const company = this.form.company.trim();
            const email = this.form.email.trim();

            this.isLoading = true;

            this.$api({
                url: '/LoginPage/UserResetPassword',
                data: {
                    cmp: company,
                    email,
                },
                method: 'POST',
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '信件已發送，請收信重設密碼。',
                        type: 'success',
                    });
                    this.$router.push('/login');
                })
                .catch((err) => {
                    if (err.response) {
                        this.showErrorMsg(err.response.data);
                    } else if (err.request) {
                        this.showErrorMsg('目前無法連線到主機，請稍後再試。');
                    } else {
                        this.showErrorMsg('發生未知的錯誤，請稍後再試。');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showErrorMsg(msg) {
            this.errorMsg = msg;
        },
    },
    mounted() {
        const urlCompany = this.$route.query.company;
        if (urlCompany) {
            this.form.company = urlCompany;
        }

        const urlEmail = this.$route.query.email;
        if (urlEmail) {
            this.form.email = urlEmail;
        }
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.login-page {
    display: table;
    width: 100%;
    height: 100%;

    .centerer {
        display: table-cell;
        vertical-align: middle;
        padding: 15px;
    }

    .login-card {
        display: table;
        max-width: 900px;
        margin: 0 auto 10vh auto;
        background-color: #fff;
        border: 6px solid #fff;
        border-radius: 23px;
        overflow: hidden;
        box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);

        .img-side {
            position: relative;
            vertical-align: top;
            display: none;
            width: 330px;
            background-color: $main-color;
            border-top-left-radius: 18px;
            border-bottom-left-radius: 18px;
            background-repeat: no-repeat;
            background-size: cover;

            @media (min-width: 992px) {
                display: table-cell;
            }

            .logo {
                position: absolute;
                top: 10px;
                left: 10px;
                width: 130px;
            }
        }

        .form-side {
            vertical-align: top;
            display: table-cell;
            width: 500px;
            background-color: #fff;
            padding: 25px 25px;

            @media (min-width: 992px) {
                padding: 50px 70px;
            }

            .el-form-item__label {
                padding-bottom: 0;
                color: #888;

                &:before {
                    display: none;
                }
            }

            .el-input__inner {
                background-color: $main-color-fade;
                color: $main-color;
                border: 0;
                font-size: 12pt;
            }
        }

        #login-page-submit-btn {
            width: 100%;
            border-radius: 25px;
            font-weight: bold;

            @media (min-width: 992px) {
                min-width: 150px;
            }
        }

        .forgot-pass-btn {
            border-radius: 25px;
            border: 0;
            width: 100%;
            margin-top: 10px;

            @media (min-width: 992px) {
                width: auto;
                margin-top: 0;
            }
        }
    }
}

#login-forgot-pass-msg {
    padding: 10px;

    .title {
        color: $main-color;
        font-size: 12pt;
        margin-bottom: 12px;
    }

    p {
        line-height: 160%;
    }
}
</style>
